import { comp } from "../func/comp";
import { $iter } from "../iterator";
import { multiplex } from "./multiplex";
import { rename } from "./rename";
export function multiplexObj(...args) {
    const iter = $iter(multiplexObj, args);
    if (iter) {
        return iter;
    }
    const [xforms, rfn] = args;
    const ks = Object.keys(xforms);
    return comp(multiplex.apply(null, ks.map((k) => xforms[k])), rename(ks, rfn));
}
